import { normalizePhone } from './firebase';

const LOCAL_PARTICIPANT_NAMES_KEY = 'clero_local_participant_names_v1';

const sanitizeLocalParticipantName = (phone: string, value: string | null | undefined) => {
  const normalizedPhone = normalizePhone(String(phone || ''));
  const trimmed = String(value || '').trim();
  if (!normalizedPhone || !trimmed) return '';
  if (trimmed.toLowerCase() === 'you') return '';
  if (normalizePhone(trimmed) === normalizedPhone) return '';
  return trimmed;
};

const readLocalParticipantNameMap = (): Record<string, string> => {
  if (typeof window === 'undefined') return {};
  try {
    const raw = window.localStorage.getItem(LOCAL_PARTICIPANT_NAMES_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return {};
    return Object.entries(parsed as Record<string, string>).reduce((acc, [phone, name]) => {
      const normalizedPhone = normalizePhone(phone);
      const sanitizedName = sanitizeLocalParticipantName(normalizedPhone, name);
      if (normalizedPhone && sanitizedName) acc[normalizedPhone] = sanitizedName;
      return acc;
    }, {} as Record<string, string>);
  } catch {
    return {};
  }
};

const writeLocalParticipantNameMap = (value: Record<string, string>) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LOCAL_PARTICIPANT_NAMES_KEY, JSON.stringify(value));
  } catch {
    // Best effort only.
  }
};

export const getLocalParticipantName = (phone: string | null | undefined) => {
  const normalizedPhone = normalizePhone(String(phone || ''));
  if (!normalizedPhone) return '';
  return readLocalParticipantNameMap()[normalizedPhone] || '';
};

export const rememberLocalParticipantName = (phone: string | null | undefined, name: string | null | undefined) => {
  const normalizedPhone = normalizePhone(String(phone || ''));
  const sanitizedName = sanitizeLocalParticipantName(normalizedPhone, name);
  if (!normalizedPhone || !sanitizedName) return '';

  const next = {
    ...readLocalParticipantNameMap(),
    [normalizedPhone]: sanitizedName,
  };
  writeLocalParticipantNameMap(next);
  return sanitizedName;
};
